import { handleActions } from 'redux-actions';
import { INIT } from '../../actions/types';

export const INITIAL_STATE = {
  keyword: null,
  articleUrl: null,
  hideCloseButton: false,
  darkMode: false,
};

export const reducer = handleActions(
  {
    [INIT]: (state, { payload }) => {
      if (payload && payload.customOptions) {
        return {
          ...state,
          ...payload.customOptions,
        };
      }

      // In case there is no suitable replacement for `state` we'll just keep it as it is.
      return state;
    },
  },
  INITIAL_STATE,
);
